import { render, staticRenderFns } from "./html-editor-component.vue?vue&type=template&id=a9ac39bc&scoped=true"
import script from "./html-editor-component.ts?vue&type=script&lang=ts&external"
export * from "./html-editor-component.ts?vue&type=script&lang=ts&external"
import style0 from "./html-editor-component.scss?vue&type=style&index=0&id=a9ac39bc&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ac39bc",
  null
  
)

export default component.exports